// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/samlarsen-disney/Documents/sld.codes/sld-wall/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-generator-js": () => import("/Users/samlarsen-disney/Documents/sld.codes/sld-wall/src/pages/generator.js" /* webpackChunkName: "component---src-pages-generator-js" */),
  "component---src-pages-index-js": () => import("/Users/samlarsen-disney/Documents/sld.codes/sld-wall/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

